import React from "react";

const AccountDeletion = () => {
  return (
    <div className="container my-5 pt-5">
      {/* Page Title */}
      <h1 className="fw-bold mb-4" style={{ color: "#153555" }}>
        Account Deletion
      </h1>

      {/* Account Deletion Section */}
      <h4 className="fw-semibold mt-4">Account Deletion</h4>
      <p className="text-secondary">
        Fred Hour allows users to request deletion of their account and associated data at any time.
      </p>
      <p className="text-secondary">
        <strong>How to request account deletion:</strong>
      </p>
      <ul className="text-secondary">
        <li>Send an email to <strong>info@fredhour.com.np</strong></li>
        <li>Use the subject line: "Account Deletion Request"</li>
        <li>Include the Gmail account or email address used to log in to the app</li>
      </ul>
      <p className="text-secondary">
        After verification, account deletion will be completed within 7 working days.
      </p>

      {/* Data That Will Be Deleted */}
      <h4 className="fw-semibold mt-4">Data That Will Be Deleted</h4>
      <p className="text-secondary">
        Once your account is deleted, the following data will be permanently removed:
      </p>
      <ul className="text-secondary">
        <li>User account information</li>
        <li>Email address and profile details</li>
        <li>App usage data</li>
        <li>Device identifiers (Device ID)</li>
      </ul>
      <p className="text-secondary">
        Some non-personal data such as security or audit logs may be retained for up to 30 days
        to comply with legal or security requirements.
      </p>

      {/* Contact */}
      <h4 className="fw-semibold mt-4">Contact</h4>
      <p className="text-secondary">
        If you have questions regarding account deletion, contact us at:
      </p>
      <p className="text-secondary">
        <strong>Email:</strong> info@fredhour.com.np<br/>
        <strong>Company:</strong> Fred Hour Pvt. Ltd.
      </p>
    </div>
  );
};

export default AccountDeletion;